module.exports = __webpack_public_path__ + "static/media/ForwardProgress.a6095dfd.svg";